//  Glossary tooltip

var Glossary = {

	selector: '[data-glossary-open]',
	content: '[data-glossary-content]',
	buttonClose: '[data-glossary-close]',
	pageEditMode: '.pagemode-edit',

	init: function () {
		if (!$(this.selector).length) return;

		this.createTitle();
		this.bindClickOpen();
	},

	bindClickOpen: function () {

		$(Glossary.selector).on('click', function (event) {

			var $thisSelector = $(this);
			var thisSelectorAttr = $thisSelector.attr('data-glossary-open');

			// Prevent default anchor click behavior
			event.preventDefault();

			Glossary.findMatchContent($thisSelector, thisSelectorAttr);
			Glossary.unbindClickEvent($thisSelector);

		});
	},

	createTitle: function () {

		// remove any existing title - this is to fix the content editor bug 
		$('.modal__content').find('h2.h3.exclude-navigation').remove();

		// return function if you are in edit mode in the cms
		if ($(LinksExternal.pageEditMode).length) return;

		$(Glossary.selector).each(function () {

			var $this = $(this),
				thisText = $this.text().trim(),
				thisTextUppercase = thisText[0].toUpperCase() + thisText.substring(1),
				thisTitle = '<h2 class="h3 exclude-navigation">' + thisTextUppercase + '</h2>',
				thisAttr = $this.attr('data-glossary-open'),
				idLabel = thisAttr + '-label',
				idDescription = thisAttr + '-desc',
				descrWrapper = '<div id="' + idDescription + '"></div>',


				// find the content that matches the attribute of the selector
				matchedContentAttr = '[data-glossary-content="' + thisAttr + '"]',
				$matchedContentEl = $(matchedContentAttr),
				thisContent = $matchedContentEl.find('.modal__content');

			// add aria attributes
			$matchedContentEl.attr('aria-labelledby', idLabel);
			$matchedContentEl.attr('aria-describedby', idDescription);
			$(Glossary.content).attr('aria-modal', true);

			// add title to modal content
			thisContent.prepend(thisTitle);
			thisContent.find('h2').attr('id', idLabel);

			// add wrapper to the main content
			thisContent.find('h2').siblings().wrapAll(descrWrapper);

		});

	},

	unbindClickEvent: function ($thisSelector) {
		$thisSelector.off("click");
	},

	findMatchContent: function ($thisSelector, thisSelectorAttr) {

		// find the content that matches the attribute of the selector
		var matchedContentAttr = '[data-glossary-content="' + thisSelectorAttr + '"]';
		var $matchedContentEl = $(matchedContentAttr);

		Glossary.showModal($thisSelector, $matchedContentEl);
		Glossary.bindClickClose($thisSelector, $matchedContentEl);
		Glossary.setFocus($matchedContentEl);
	},

	bindClickClose: function ($thisSelector, $matchedContentEl) {

		var $thisBtClose = $matchedContentEl.find(Glossary.buttonClose);

		$thisBtClose.on('click', function (e) {

			//prevent default clicks
			e.preventDefault();

			Glossary.hideModal($thisSelector, $matchedContentEl);
			$thisSelector.trigger('focus');
			Glossary.unbindClickEvent($thisBtClose);
		});
	},

	showModal: function ($thisSelector, $matchedContentEl) {

		$thisSelector.addClass('active');
		Glossary.bindKeyDownClose($thisSelector, $matchedContentEl);
		Glossary.bindClickOutside($thisSelector, $matchedContentEl);
	},

	bindClickOutside: function ($thisSelector, $matchedContentEl) {

		// Get the modal
		var currentContentainer = $matchedContentEl.find('.modal__container')[0];

		// if user click outsidde the content area to hide modal
		$('.modal').on('click', function (e) {

			var $thisTarget = $(e.target)[0];

			if ($thisTarget === currentContentainer) {
				Glossary.hideModal($thisSelector, $matchedContentEl);
				$thisSelector.trigger('focus');

				//prevent default clicks and stop propagation
				e.preventDefault();
				e.stopPropagation();
			}

		});

	},

	hideModal: function ($thisSelector, $matchedContentEl) {

		// hide modal window
		$thisSelector.removeClass('active');
		Glossary.removeFocus($thisSelector, $matchedContentEl);
		Glossary.unbindClickEvent($(Glossary.buttonClose));
		Glossary.bindClickOpen();
	},

	setFocus: function ($matchedContentEl) {

		var $childContainer = $matchedContentEl.find('.modal__container'),
			$childContent = $childContainer.find('.modal__content'),
			$focusableElements = $childContainer.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
			firstFocusedEl = $focusableElements[0],
			lastFocusedEl = $focusableElements[$focusableElements.length - 1];

		// set aria attributes and remove focus
		$('.modal__content').removeAttr('tabindex');
		$matchedContentEl.attr('aria-hidden', false);
		$childContent.attr('tabindex', '-1');

		// set focus
		setTimeout(function () {
			$childContent.trigger('focus');
		}, 100);


		$('body').on('keydown', function (e) {

			var isTabPressed = e.key === 'Tab';

			if (!isTabPressed) {
				return;
			}

			// if shift key pressed for shift + tab combination
			if (e.shiftKey) {
				if (document.activeElement === firstFocusedEl) {
					// add focus for the last focusable element
					$(lastFocusedEl).trigger('focus');
				}
			} else { // if tab key is pressed
				// if focused has reached to last focusable element then focus first focusable element after pressing tab
				if (document.activeElement === lastFocusedEl) {
					// add focus for the first focusable element
					$(firstFocusedEl).trigger('focus');
					e.preventDefault();
				}
			}
		});

	},

	removeFocus: function ($thisSelector, $matchedContentEl) {

		// set aria attributes and remove the focus
		$matchedContentEl.attr('aria-hidden', true);
		$('.modal__content').removeAttr('tabindex');

		// set focus
		setTimeout(function () {
			$thisSelector.trigger('focus');
		}, 100);
	},

	bindKeyDownClose: function ($thisSelector, $matchedContentEl) {

		$(document).on('keydown.modal__content', function (e) {

			// if user press key Esc close modal
			if (e.key === "Escape") {

				//prevent default clicks
				e.preventDefault();
				Glossary.hideModal($thisSelector, $matchedContentEl);

			}

		});
	}

};

$(document).ready(function () {
	Glossary.init();
});